/** * プレイスカードコンポーネント */
<template>
  <div class="card-place">
    <b-card-text
      align="left"
      class="event-card-body"
      v-on:click="$_onClickCard"
    >
      <div class="event-card-body-left">
        <!-- プレイス名 -->
        <div
          class="event-card-title"
          v-bind:class="{
            'is-fixed': isFixedPosition,
            'is-unfixed': !isFixedPosition,
          }"
        >
          <p v-on:click="$_onClickTitle">
            {{ placeName }}
          </p>
          <span v-if="existsAttachFiles" class="attach-file">
            {{ attachFilesCount }}
          </span>
        </div>
        <!-- プレイス住所 -->
        <p class="event-card-description">
          {{ placeAddress }}
        </p>
        <!-- データリスト -->
        <data-list v-bind:data="dataList" />
      </div>
      <div class="event-card-body-right">
        <!-- 未確定アイコン -->
        <div class="place-notice-box">
          <p v-if="!isFixedPosition" class="label-unfixed">
            {{ $t('appCardPlace.positionUnfixed') }}
          </p>
        </div>
        <!-- 詳細ボタン -->
        <div class="place-action-box">
          <div
            v-if="!noDetailButton"
            class="button-detail btn-secondary"
            v-on:click="$_onClickDetailButton"
          >
            {{ $t('appCardPlace.detail') }}
          </div>
        </div>
      </div>
    </b-card-text>
  </div>
</template>

<script>
import DataList from '@/components/AppDataList.vue'

/**
 * タイムラインタイプ（機能のタイプ)
 * @type {number}
 */
const TIMELINE_TYPE = 8

export default {
  components: {
    'data-list': DataList,
  },
  props: {
    /**
     * 詳細ボタンを非表示にする場合はtrue
     */
    noDetailButton: {
      type: Boolean,
      default: false,
    },
    /**
     * ID
     * (データを一意に識別することができるID。タイムラインID、プレイスID)
     */
    id: {
      type: Number,
      default: null,
      required: true,
    },
    /**
     * プレイス名
     */
    placeName: {
      type: String,
      default: null,
      required: true,
    },
    /**
     * プレイス住所
     */
    placeAddress: {
      type: String,
      default: null,
      required: false,
    },
    /**
     * 添付ファイル数
     */
    attachFilesCount: {
      type: Number,
      default: null,
      required: false,
    },
    /**
     * プレイスグループ名リスト
     */
    placeGroupNames: {
      type: Array,
      default: null,
      required: false,
    },
    /**
     * 担当者名リスト
     */
    placeUserRelationNames: {
      type: Array,
      default: null,
      required: false,
    },
    /**
     * 担当者グループ名リスト
     */
    placeOrganizationRelationNames: {
      type: Array,
      default: null,
      required: false,
    },
    /**
     * 位置確定している場合はtrue
     */
    isFixedPosition: {
      type: Boolean,
      default: null,
      required: false,
    },
  },

  data: function () {
    return {}
  },

  computed: {
    /**
     * 添付ファイルが存在している場合はtrueを返却する
     * @return {boolean}
     */
    existsAttachFiles: function () {
      return this.attachFilesCount > 0
    },
    /**
     * DataListコンポーネントに設定するデータ
     * @type {Array.<Object>}
     */
    dataList: function () {
      return {
        standard: [
          {
            label: this.$t('appCardPlace.field.group'),
            value: this.placeGroupNames
              ? this.placeGroupNames.join(', ')
              : null,
          },
          {
            label: this.$t('appCardPlace.field.relatedUser'),
            value: this.placeRelations.join(', '),
          },
        ],
      }
    },
    /**
     * 担当グループ/ユーザー名配列
     * @type {Array.<String>}
     */
    placeRelations: function () {
      return [
        ...(this.placeOrganizationRelationNames || []),
        ...(this.placeUserRelationNames || []),
      ]
    },
  },

  methods: {
    /**
     * クリック時のイベント
     */
    $_onClickCard: function () {
      this.$emit('placecard-click', TIMELINE_TYPE, this.id)
    },

    /**
     * タイトルクリック時のイベント
     */
    $_onClickTitle: function (event) {
      event.stopPropagation()
      this.$emit('placecard-title-click', TIMELINE_TYPE, this.id)
    },

    /**
     * 詳細ボタンクリック時のイベント
     */
    $_onClickDetailButton: function (event) {
      event.stopPropagation()
      this.$emit('placecard-detail-click', TIMELINE_TYPE, this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-place {
  height: 160px;
}

.event-card-body {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #f6f6f6;
  border-radius: 2px;
  overflow: hidden;
  transition: 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
}

.event-card-body-left {
  width: calc(100% - 100px);
  height: 100%;
  padding: 20px 10px 20px 20px;

  ::v-deep .data-list-row {
    min-width: 0;
  }

  ::v-deep .data-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.event-card-body-right {
  position: relative;
  width: 100px;
  height: 100%;
}

.event-card-title {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  p {
    color: $text-color-link;
    font-weight: bold;
    font-size: 0.9em !important;

    &:before {
      content: '';
      display: inline-block;
      // width: 20px;
      width: 0;
      height: 20px;
      // margin-right: 8px;
      position: relative;
      top: 4px;
    }

    &:hover {
      text-decoration: underline;
    }

    a {
      color: $text-color-link;
      font-weight: bold;
      margin-right: 4px;
    }
  }

  // &.is-unfixed {
  //   p:before {
  //     background: url('../assets/ifield/place.png') no-repeat;
  //     background-size: 20px 20px;
  //   }
  // }

  // &.is-fixed {
  //   p:before {
  //     background: url('../assets/ifield/place_fixed.png') no-repeat;
  //     background-size: 20px 20px;
  //   }
  // }
}

.attach-file {
  color: #808080;
  margin-left: 10px;

  &:before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 2px;
    background: url('../../assets/ifield/icon_attach_file.png') no-repeat;
    background-size: 16px 16px;
    position: relative;
    top: 2px;
  }
}

.event-card-description {
  margin-bottom: 15px;
  color: #4d4d4d;
  font-size: 0.8em;
  line-height: 1.4;
}

.label-unfixed {
  background-color: #c62f4d;
  border-radius: 3px;
  width: 55px;
  height: 20px;
  margin: 0 0 0 auto;
  color: #ffffff;
  font-size: 0.6em;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
}

.place-notice-box {
  padding: 20px 20px 20px 0;
  width: 100%;
}

.place-action-box {
  bottom: 20px;
  position: absolute;
  width: 100%;
  padding: 0 20px;
}

.button-detail {
  border-radius: 3px;
  width: 55px;
  height: 20px;
  margin: 0 0 0 auto;
  font-size: 0.6em;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
}
</style>
